import React from 'react';

/* Components */

import Portal from 'components/Portal';
import AlertStack from 'components/AlertStack';

function AlertRenderer() {
	return (
		<Portal>
			<AlertStack position="fixed" bottom="m" right="m" />
		</Portal>
	);
}

export default AlertRenderer;
